<template>
  <EditorButton :title="$t('table')">
    <template v-slot:trigger="{ hide, show }">
      <MDropdown
        :trigger="['click']"
        :options="options"
        @hide="$emit('hide')"
        @change="handleOptionSelected"
      >
        <template v-slot:trigger="{ toggle }">
          <MButton
            variant="transparent"
            class="text-neutral-darker"
            size="small"
            :shadow="false"
            @click.prevent="toggle"
            @click="toggle"
            @mouseenter="show"
            @mouseleave="hide"
          >
            <slot />
          </MButton>
        </template>
      </MDropdown>
    </template>
  </EditorButton>
</template>

<script>
import EditorButton from './editor-button'
export default {
  name: 'TableButton',
  components: { EditorButton },
  props: {
    active: { type: Boolean, default: false },
    commands: { type: Object, required: true },
  },
  computed: {
    options() {
      let o = [{ text: `${this.$t('add')} ${this.$t('table')}`, key: 'table' }]
      const additionalOptions = [
        {
          text: `${this.$t('add')} ${this.$t('border')}`,
          key: 'add_border',
        },
        {
          text: `${this.$t('remove')} ${this.$t('border')}`,
          key: 'remove_border',
        },
        {
          text: `${this.$t('merge')} ${this.$tc('column', 2)}`,
          key: 'toggle_merge_cells',
        },
        {
          text: `${this.$t('add')} ${this.$tc('column')} ${this.$t(
            'slaModule.before'
          )}`,
          key: 'add_column_before',
        },
        {
          text: `${this.$t('add')} ${this.$tc('column')} ${this.$t(
            'slaModule.after'
          )}`,
          key: 'add_column_after',
        },
        {
          text: `${this.$t('remove')} ${this.$tc('column')}`,
          key: 'delete_column',
        },
        {
          text: `${this.$t('add')} ${this.$tc('row')} ${this.$t(
            'slaModule.before'
          )}`,
          key: 'add_row_before',
        },
        {
          text: `${this.$t('add')} ${this.$tc('row')} ${this.$t(
            'slaModule.after'
          )}`,
          key: 'add_row_after',
        },
        {
          text: `${this.$t('remove')} ${this.$tc('row')}`,
          key: 'delete_row',
        },
        { text: `${this.$t('remove')} ${this.$t('table')}`, key: 'delete' },
      ]
      if (this.active) {
        o = o.concat(additionalOptions)
      }
      return o
    },
  },
  methods: {
    handleOptionSelected($event) {
      switch ($event.key) {
        case 'table':
          this.commands.createTable({
            rowsCount: 3,
            colsCount: 3,
            withHeaderRow: false,
          })
          break
        case 'toggle_merge_cells':
          this.commands.toggleCellMerge()
          break
        case 'add_row_before':
          this.commands.addRowBefore()
          break
        case 'add_row_after':
          this.commands.addRowAfter()
          break
        case 'delete_row':
          this.commands.deleteRow()
          break
        case 'add_column_before':
          this.commands.addColumnBefore()
          break
        case 'add_column_after':
          this.commands.addColumnAfter()
          break
        case 'delete_column':
          this.commands.deleteColumn()
          break
        case 'delete':
          this.commands.deleteTable()
          break
        case 'remove_border':
          this.commands.setCellAttr({
            name: 'border',
            value: 'none',
          })
          break
        case 'add_border':
          this.commands.setCellAttr({
            name: 'border',
            value: '1px solid var(--border-color)',
          })
          break
        default:
          break
      }
    },
  },
}
</script>
